import axios, {AxiosPromise} from "axios";
import LightDto from "./LightDto";

class PlugClient {
    private readonly _baseUrl: string;

    constructor(baseUrl: string) {
        this._baseUrl = baseUrl;
    }

    getAll(): AxiosPromise {
        const url = `${this._baseUrl}/intern/plug/states/`;
        return axios.get<Array<LightDto>>(url);
    }

    togglePlug(id: number, status: string): AxiosPromise {
        const url = `${this._baseUrl}/intern/plug/set/${id}/${status}`;
        return axios.post(url, {})
            .then(response => this.getAll());
    }
}

export default PlugClient;